var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAverageDurationImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M0 35.4984H2.83057C5.66114 35.4984 11.3223 35.4984 16.9834 30.4914C22.6446 25.5595 28.3057 15.4331 33.9668 12.489C39.628 9.43233 45.2891 13.5579 50.9502 11.4951C56.6114 9.43233 62.2725 1.55626 67.9337 1.5C73.5948 1.55626 79.2559 9.43233 82.0865 13.5016L84.9171 17.4959V47.5H82.0865C79.2559 47.5 73.5948 47.5 67.9337 47.5C62.2725 47.5 56.6114 47.5 50.9502 47.5C45.2891 47.5 39.628 47.5 33.9668 47.5C28.3057 47.5 22.6446 47.5 16.9834 47.5C11.3223 47.5 5.66114 47.5 2.83057 47.5H0",
    fill: "url(#paint0_linear_2904_148)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.7288H2.83057C5.66114 35.7288 11.3223 35.7288 16.9834 30.7219C22.6446 25.79 28.3057 15.6636 33.9668 12.7195C39.628 9.6628 45.2891 13.7884 50.9502 11.7256C56.6114 9.6628 62.2725 1.78673 67.9337 1.73047C73.5948 1.78673 79.2559 9.6628 82.0865 13.7321L84.9171 17.7264",
    stroke: "black",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2904_148",
    x1: 0,
    y1: 1.5,
    x2: 0,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB55",
    stopOpacity: 0.16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageDurationImg);
export default __webpack_public_path__ + "static/media/averageDurationImg.9413aea9f56f1689f80873f442d0b39f.svg";
export { ForwardRef as ReactComponent };